import { supabase } from '@/lib/supabase';
import type { CompanyInfo, ApiResponse } from '@/types';

export const companyInfoService = {
  /**
   * 활성화된 회사 정보 조회
   */
  async getCompanyInfo(): Promise<ApiResponse<CompanyInfo>> {
    try {
      const { data, error } = await supabase
        .from('company_info')
        .select('*')
        .eq('is_active', true)
        .single();

      if (error) {
        console.error('Error fetching company info:', error);
        return {
          success: false,
          error: '회사 정보를 불러오는데 실패했습니다'
        };
      }

      if (!data) {
        return {
          success: false,
          error: '회사 정보를 찾을 수 없습니다'
        };
      }

      return {
        success: true,
        data: data as CompanyInfo
      };
    } catch (error) {
      console.error('Unexpected error fetching company info:', error);
      return {
        success: false,
        error: '예상치 못한 오류가 발생했습니다'
      };
    }
  },

  /**
   * 회사 정보 업데이트 (관리자용 - 향후 사용)
   */
  async updateCompanyInfo(id: string, updateData: Partial<CompanyInfo>): Promise<ApiResponse<CompanyInfo>> {
    try {
      const { data, error } = await supabase
        .from('company_info')
        .update({
          ...updateData,
          updated_at: new Date().toISOString()
        })
        .eq('id', id)
        .select()
        .single();

      if (error) {
        console.error('Error updating company info:', error);
        return {
          success: false,
          error: '회사 정보 업데이트에 실패했습니다'
        };
      }

      return {
        success: true,
        data: data as CompanyInfo,
        message: '회사 정보가 성공적으로 업데이트되었습니다'
      };
    } catch (error) {
      console.error('Unexpected error updating company info:', error);
      return {
        success: false,
        error: '예상치 못한 오류가 발생했습니다'
      };
    }
  }
};